<mat-dialog-content fxLayout="column">
    <p [style.margin-bottom]="externalTemplate ? 0 :''" [innerHtml]='message | safeHtml'></p>
    <ng-container [ngTemplateOutlet]="externalTemplate? externalTemplate : ''" [ngTemplateOutletContext]="externalTemplateContext"></ng-container>
</mat-dialog-content>
<mat-dialog-actions align="center">
    <button *ngIf="!isDisableNoButton" mat-button mat-dialog-close>{{falseTitle}}</button>
    <button *ngIf="alternateTitle!= null" mat-button [mat-dialog-close]="alternateReturnData" [disabled]="isDisabled"
        cdkFocusInitial>{{alternateTitle}}</button>
    <button mat-button *ngIf="yesTitle != 'DISABLED'" [mat-dialog-close]="true" [disabled]="isDisabled" cdkFocusInitial (click)="copyToClipboard()">{{yesTitle}}</button>
</mat-dialog-actions>